export default __webpack_public_path__ + "static/media/img10.72cd22e6.PNG";